import { freezeBody, unfreezeBody } from './freezeScroll';

const videoCtas = Array.from(document.querySelectorAll('.video-cta'));
const exitVideo = document.querySelector('.video-overlay__exit');
const videoOverlay = document.querySelector('.video-overlay');
const youtubeLinks = Array.from(
  document.querySelectorAll('.youtube-overlay-link')
);

const openOverlay = () => {
  freezeBody();
  videoOverlay.classList.add('video-overlay--active');
};

const closeOverlay = () => {
  unfreezeBody();
  videoOverlay.classList.remove('video-overlay--active');
  const videoButton = document.querySelector('.video-button');
  if (videoButton) {
    videoButton.remove();
  }
};

const removeVideoOverlay = (e, func) => {
  e.preventDefault();
  closeOverlay();
  setTimeout(() => func, 200);
};

const onPlayerReady = e => {
  // e.target.playVideo();
};

const createYouTube = cta => {
  const videoId = cta.dataset.id;
  const player = new YT.Player('player', {
    videoId: videoId,
    playerVars: {
      autoplay: 1,
      modestbranding: 1,
      rel: 0
    },
    events: {
      onReady: onPlayerReady
    }
  });
  addVideoCta(cta);
  openOverlay();
  exitVideo.addEventListener('click', e => {
    removeVideoOverlay(e, player.destroy());
  });

  videoOverlay.addEventListener('click', e => {
    removeVideoOverlay(e, player.destroy());
  });
};

const addVideoCta = cta => {
  const videoCta = cta.dataset.videoCta;
  const videoCtaUrl = cta.dataset.videoCtaUrl;

  if (videoCta !== '' && videoCta !== undefined) {
    const videoButton = document.createElement('a');
    videoButton.classList.add('button');
    videoButton.classList.add('video-button');
    videoButton.href = videoCtaUrl;
    videoButton.target = '_blank';
    videoButton.innerHTML = videoCta;
    videoOverlay.appendChild(videoButton);
  }
};

const createMP4 = cta => {
  openOverlay();
  const file = cta.dataset.file;

  const player = document.querySelector('#player');
  player.innerHTML = `
    <video class="video-el" controls>
      <source src="${file}" type="video/mp4">
    </video>
  `;
  addVideoCta(cta);
  const videoEl = document.querySelector('.video-el');
  videoEl.play();

  exitVideo.addEventListener('click', e => {
    removeVideoOverlay(e, videoEl.remove());
  });
};

const triggerVideoOverlay = (e, cta) => {
  console.log('trigerVideoOverlay', e);
  e.preventDefault();
  const type = cta.dataset.type;
  type === 'YouTube' ? createYouTube(cta) : createMP4(cta);
  console.log(type);

  document.querySelector('.video-button').addEventListener('click', e => {
    e.stopImmediatePropagation();
  });
};
console.log(videoCtas);
if (videoCtas) {
  const ctaArray = Array.from(videoCtas);
  ctaArray.forEach(el => {
    el.addEventListener('click', e => triggerVideoOverlay(e, el));
  });
}

if (youtubeLinks) {
  const youtubeLinksArray = Array.from(youtubeLinks);
  youtubeLinksArray.forEach(el => {
    el.addEventListener('click', e => openYoutubeLink(el, e));
  });
}

const openYoutubeLink = (el, e) => {
  e.preventDefault();
  const href = el.getAttribute('href');
  const videoId = getYoutubeId(href);
  const player = new YT.Player('player', {
    videoId: videoId,
    playerVars: { 'autoplay': 1,'rel': 0 },
    events: {
      onReady: onPlayerReady
    }
  });
  openOverlay();
  exitVideo.addEventListener('click', e => {
    removeVideoOverlay(e, player.destroy());
  });

  videoOverlay.addEventListener('click', e => {
    removeVideoOverlay(e, player.destroy());
  });
};

const getYoutubeId = url => {
  var ID = '';
  url = url
    .replace(/(>|<)/gi, '')
    .split(/(vi\/|v=|\/v\/|youtu\.be\/|\/embed\/)/);
  if (url[2] !== undefined) {
    ID = url[2].split(/[^0-9a-z_\-]/i);
    ID = ID[0];
  } else {
    ID = url;
  }
  return ID;
};
